import React, { Component } from 'react';

class IconSearch extends Component {
    render() {
        return (
            <div className="h-6 w-6 2xl:h-7 2xl:w-7">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.621 29.621" fill="none" stroke="#8d8989" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3px"><g transform="translate(-3 -3)" style={{ width: "100%", height: "100%" }}><path className="a" d="M27.5,16A11.5,11.5,0,1,1,16,4.5,11.5,11.5,0,0,1,27.5,16Z" /><path className="a" d="M31.5,31.5l-6.525-6.525" transform="translate(-1 -1)" /></g></svg>
            </div>
        );
    }
}

export default IconSearch;